import React, { useState, useEffect } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useTranslation } from "react-i18next";
import DirectoryApi from "../../../api/directoryApi";
import ProgramApi from "../../../api/programApi";
import { toast } from "react-toastify";
import { Form, Button, Modal } from "react-bootstrap";
import { Cookies } from "react-cookie";
const ProgramModel = ({
  show,
  onHide,
  programField,
  program,
  coupleTalkData,
  retreatData,
}) => {
  const { t } = useTranslation();
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const [validated, setValidated] = useState(false);
  const [text, setText] = useState("");
  let programApi = new ProgramApi();

  const tp = (key) => {
    return t(key, {
      lng: retreatData?.language === "spanish" ? "spanish" : "english",
    });
  };

  useEffect(() => {
    if (programField === "WisdomDescription") {
      setText(program?.wisdom_from_mt || "");
    } else if (programField === "talk_question") {
      setText(
        coupleTalkData?.talk_question ||
          '<div style="margin: 10px 0;"><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /><hr style="border: 1px solid black; margin: 30px 0;" /></div>',
      );
    } else if (programField === "tableContent") {
      setText(program?.tableContent || "");
    } else if (programField === "ParishMission") {
      setText(program?.parishMission || "");
    } else if (programField === "fbLink") {
      setText(program?.fbLink || "");
    } else if (programField === "instaLink") {
      setText(program?.instaLink || "");
    } else if (programField === "openingPrayer") {
      setText(program?.openingPrayer || tp("opening_prayer_content"));
    } else if (programField === "prayerOfProtection") {
      setText(
        program?.prayer_of_protection || tp("prayer_protection_content"),
      );
    } else if (programField === "donations") {
      setText(program?.donations || tp("donations_content"));
    } else {
      setText(program?.guidelines || "");
    }
  }, [programField, program, coupleTalkData, retreatData?.language]);

  const handleSubmit = async () => {
    try {
      const res = await programApi.createProgram({
        text: text,
        programField: programField,
        retreatId: retreatData && retreatData.id,
        programId: program && program.id,
        roasterId: coupleTalkData && coupleTalkData.id,
      });

      if (!res.success) {
        toast.error(res.msg);
        return;
      }



      toast.success(res.msg);
      onHide();
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      {programField === "fbLink" ? (
        <Modal
          show={show}
          onHide={onHide}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("facebook_link")}
            </Modal.Title>
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <Form.Group className="form-group ml-5 faceBbook-link">
                <Form.Control
                  size="sm"
                  type="text"
                  name="fbLink"
                  id="fbLink"
                  placeholder={t("facebook_link")}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                <h5 className="mt-2">{t("example_link")}</h5>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="footer-buttons">
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : programField === "instaLink" ? (
        <Modal
          show={show}
          onHide={onHide}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("instagram_link")}
            </Modal.Title>
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <Form.Group className="form-group ml-5 faceBbook-link">
                <Form.Control
                  size="sm"
                  type="text"
                  name="instaLink"
                  id="instaLink"
                  placeholder={t("instagram_link")}
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                <h5 className="mt-2">{t("example_link")}</h5>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="footer-buttons">
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            {programField === "WisdomDescription" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("wisdom_mother_theresa")}
              </Modal.Title>
            ) : null}

            {programField === "guidelines" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("add_guidelines")}
              </Modal.Title>
            ) : null}

            {programField === "openingPrayer" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("opening_prayer")}
              </Modal.Title>
            ) : null}

            {programField === "ParishMission" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("our_parish_mission")}
              </Modal.Title>
            ) : null}

            {programField === "prayerOfProtection" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("marriage_prayer_of_protection")}
              </Modal.Title>
            ) : null}

            {programField === "donations" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("donations")}
              </Modal.Title>
            ) : null}

            {programField === "talk_question" ? (
              <Modal.Title id="contained-modal-title-vcenter">
                {t("talks_questions")}
                <h5 className="mt-2">
                  {coupleTalkData.talk}, (
                  {coupleTalkData.role === "Spiritual Director"
                    ? `${coupleTalkData?.firstName || ""} ${coupleTalkData?.lastName || ""}`
                    : `${coupleTalkData?.hisFirstName || ""} ${
                        coupleTalkData?.hisFirstName ? "&" : ""
                      } ${coupleTalkData?.herFirstName || ""} ${
                        coupleTalkData?.hisLastName || ""
                      }`}
                  )
                </h5>
              </Modal.Title>
            ) : null}
          </Modal.Header>
          <Form noValidate validated={validated} className="forms-sample">
            <Modal.Body>
              <div className="program-field-editor">
              <SunEditor
                id="outlined-adornment-quote"
                type="text"
                onChange={(e) => setText(e)}
                setContents={text}
                name="quote"
                height="450px"
                inputProps={{}}
                setOptions={{
                  buttonList: [
                    ["undo", "redo", "font", "fontSize", "formatBlock"],
                    ["bold", "underline", "italic", "removeFormat"],
                    [
                      "fontColor",
                      "hiliteColor",
                      "outdent",
                      "indent",
                      "align",
                      "horizontalRule",
                      "list",
                      "lineHeight",
                    ],
                    ["fullScreen", "link", "save"],
                  ],
                }}
              />
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={handleSubmit} variant="primary" type="button">
                {t("save")}
              </Button>
              <Button onClick={onHide}>{t("close")}</Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default ProgramModel;
